import React from "react";

const SvgFootwear = (props) => (
  <svg
    width="48px"
    height="48px"
    viewBox="0 0 48 48"
    fill="currentColor"
    {...props}
  >
    <path
      fill="#BCD0FA"
      fillRule="evenodd"
      d="M13.766 25.958l-1.223 15.32h-1.73c-.062-.997-.125-1.984-.182-2.972-.345-6.046-1.288-11.97-3.518-17.644A16.126 16.126 0 016.01 15.55c-.08-1.562.339-3.031.87-4.471.537-1.454 1.296-2.773 2.508-3.784a5.905 5.905 0 012.743-1.276c.304-.058.461.012.626.28 1.67 2.72 3.053 5.583 4.325 8.505 1.318 3.032 2.6 6.08 3.994 9.077.947 2.039 2.213 3.892 4.021 5.291 2.876 2.226 6.09 2.754 9.574 1.814.252-.068.529-.11.743-.244.552-.346.996-.176 1.505.13 2.72 1.641 5.276 3.488 7.32 5.947.575.691 1.032 1.495 1.454 2.293.3.567.357 1.214.066 1.84-.116.248-.272.36-.573.36-7.134-.01-14.269-.008-21.404-.008-1.22 0-2.112-.632-2.869-1.506-.886-1.023-1.515-2.208-2.002-3.456-.807-2.065-1.534-4.161-2.343-6.226a24.757 24.757 0 00-1.376-2.952c-.24-.435-.707-.746-1.084-1.1-.07-.065-.2-.065-.342-.106"
    />
  </svg>
);

export default SvgFootwear;
